class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', (event) => {
      this.expandShowMore(event);
      const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item')
      if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
        nextElementToFocus.querySelector('input').focus()
      }
    });
  }
  expandShowMore(event) {
    const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
    const parentWrap = parentDisplay.querySelector('.parent-wrap');
    this.querySelectorAll('.label-text').forEach(element => element.classList.toggle('hidden'));
    parentDisplay.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'))
  }
}

customElements.define('show-more-button', ShowMoreButton);




var input_event = new Event('input', {
    bubbles: true,
    cancelable: true,
});
/* Start Dual Range slider logic */

function controlFromInput(fromSlider, fromInput, toInput, controlSlider, groups_def, plotter_id) {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, 'var(--facet-indent)', 'var(--facet-border)', controlSlider, groups_def, plotter_id);
    if (from > to) {
        fromSlider.value = to;
        fromInput.value = to;
    } else {
        fromSlider.value = from;
    }
    syncronizeInputs(fromInput);

}
    
function controlToInput(toSlider, fromInput, toInput, controlSlider, groups_def, plotter_id) {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, 'var(--facet-indent)', 'var(--facet-border)', controlSlider, groups_def, plotter_id);
    setToggleAccessible(toInput, toSlider);
    if (from <= to) {
        toSlider.value = to;
        toInput.value = to;
    } else {
        toInput.value = from;
    }
    syncronizeInputs(toInput);

}

function controlFromSlider(fromSlider, toSlider, fromInput, groups_def, plotter_id) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider, 'var(--facet-indent)', 'var(--facet-border)', toSlider, groups_def, plotter_id);
  if (from > to) {
    fromSlider.value = to;
    fromInput.value = to;
  } else {
    fromInput.value = from;
  }
  syncronizeInputs(fromInput);

}

function controlToSlider(fromSlider, toSlider, toInput, groups_def, plotter_id) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider, 'var(--facet-indent)', 'var(--facet-border)', toSlider, groups_def, plotter_id);
  setToggleAccessible(toSlider, toSlider);
  if (from <= to) {
    toSlider.value = to;
    toInput.value = to;
  } else {
    toInput.value = from;
    toSlider.value = from;
  }
  syncronizeInputs(toInput);
}

function syncronizeInputs(thisInput) {
  var this_name = thisInput.getAttribute("name");
  document.querySelectorAll("input[name='"+this_name+"']").forEach(input_candidate => {
    if(input_candidate != thisInput) {
      input_candidate.value = thisInput.value;
      input_candidate.dispatchEvent(input_event);
    }
  });
}

function getParsed(currentFrom, currentTo) {
  const from = parseInt(currentFrom.value, 10);
  const to = parseInt(currentTo.value, 10);
  return [from, to];
}

function fillSlider(from, to, sliderColor, rangeColor, controlSlider, groups_def, plotter_id) {
    var range_min = from.min;
    const rangeDistance = to.max- range_min;
    const fromPosition = from.value - range_min;
    const toPosition = to.value - range_min;

    chooseSelected(from, to, groups_def, plotter_id);

    controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition)/(rangeDistance)*100}%,
      ${rangeColor} ${((fromPosition)/(rangeDistance))*100}%,
      ${rangeColor} ${(toPosition)/(rangeDistance)*100}%, 
      ${sliderColor} ${(toPosition)/(rangeDistance)*100}%, 
      ${sliderColor} 100%)`;
}

function chooseSelected(from, to, groups_def, plotter_id) {
    for(var g_d_i in groups_def) {
      var plot_id = makePlotID(plotter_id, g_d_i);
      var plot = document.querySelector("#"+plot_id );
      if(groups_def[g_d_i].min >= from.value && groups_def[g_d_i].max <= to.value) {
        plot.classList.add("active");
      } else {
        if( plot.classList.contains("active") ) {
          plot.classList.remove("active");
        }
      }
    }
}



function setToggleAccessible(currentTarget, toSlider) {
  if (Number(currentTarget.value) <= 0 ) {
    toSlider.style.zIndex = 2;
  } else {
    toSlider.style.zIndex = 0;
  }
}

function plotSliderGraph($slider_graph, values, grouped_increment_count, range_min, range_max, plotter_id) {
  var plottable_values = groupValues(values, grouped_increment_count, range_min, range_max);
  for(var p_i in plottable_values["groups"]) {
    var group_cnt = plottable_values["groups"][p_i];
    var div = document.createElement('div');
    var height_percent = (group_cnt/plottable_values["max_value"])*100;
    div.style.height = String(height_percent)+"%";
    div.dataset.min = plottable_values["groups_def"][p_i]["min"];
    div.setAttribute('id',makePlotID(plotter_id,p_i));
    div.dataset.max = plottable_values["groups_def"][p_i]["max"];
    $slider_graph.appendChild(div);
  }
  return plottable_values["groups_def"];
    
}

function makePlotID(plotter_id, p_i) {
  return "plot_"+plotter_id+"_"+p_i;
}

function groupValues(values, grouped_increment_count, range_min, range_max) {
  var grouped_values = Array(grouped_increment_count).fill(0);
  values = JSON.parse(values);
  var increment_size = (range_max - range_min) / (grouped_increment_count);
  var grouped_definitions = [];
  for(var i in grouped_values) {
    var min = range_min + (i*increment_size);
    var max = min + increment_size;
    grouped_definitions.push({ min: min, max: max });
  }
  var max_value = 0;
  for(var i in values) {
    var distance_from_min = values[i] - range_min;
    var grouped_values_index = Math.floor(distance_from_min / increment_size);
    if(grouped_values_index >= grouped_values.length ) {
      grouped_values_index = grouped_values.length-1;
    }
    grouped_values[grouped_values_index] += 1;
    if(grouped_values[grouped_values_index] > max_value) {
      max_value = grouped_values[grouped_values_index];
    }
  }
  return {
    groups: grouped_values,
    groups_def: grouped_definitions,
    max_value: max_value
  }
}


function initiate() {
  console.log("DOMContentLoaded!");
  var $dual_range_sliders = document.querySelectorAll(".dual_range_container");
  for (var i = 0; i < $dual_range_sliders.length; ++i) {
    var $slider_container = $dual_range_sliders[i];

    var $slider_graph = $slider_container.querySelector(".sliders_graph");
    var plotter_id = $slider_graph.getAttribute('id');

    var grouped_increment_count = Number($slider_graph.dataset.groupedIncrementCount);
    var range_min = Number($slider_graph.dataset.rangeMin);
    var range_max = Number($slider_graph.dataset.rangeMax);
    var values = $slider_graph.dataset.values;

    if(values) {
      var groups_def = plotSliderGraph($slider_graph, values, grouped_increment_count, range_min, range_max, plotter_id);
    }

    var fromSlider = $slider_container.querySelector(".from_slider");
    var toSlider = $slider_container.querySelector(".to_slider");
    var fromSliderID = fromSlider.getAttribute('id');
    var toSliderID = toSlider.getAttribute('id');
    var fromInputID = fromSliderID.replace("-Slider","");
    var toInputID = toSliderID.replace("-Slider","");
    var fromInput = document.querySelector("#"+fromInputID);
    var toInput = document.querySelector("#"+toInputID);
    fillSlider(fromSlider, toSlider, 'var(--facet-indent)', 'var(--facet-border)', toSlider, groups_def, plotter_id);
    setToggleAccessible(toSlider, toSlider);

    function makeFromSliderCallback(fromSlider, toSlider, fromInput, groups_def, plotter_id) {
      return function(e) {
        controlFromSlider(fromSlider, toSlider, fromInput, groups_def, plotter_id);
      }
    }
    fromSlider.oninput = makeFromSliderCallback(fromSlider, toSlider, fromInput, groups_def, plotter_id);


    function makeToSliderCallback(fromSlider, toSlider, toInput, groups_def, plotter_id) {
      return function(e) {
        controlToSlider(fromSlider, toSlider, toInput, groups_def, plotter_id);
      }
    }
    toSlider.oninput = makeToSliderCallback(fromSlider, toSlider, toInput, groups_def, plotter_id);

    function makeFromInputCallback(fromSlider, fromInput, toInput, toSlider, groups_def, plotter_id) {
      return function(e) {
        controlFromInput(fromSlider, fromInput, toInput, toSlider, groups_def, plotter_id);
      }
    }
    fromInput.oninput = makeFromInputCallback(fromSlider, fromInput, toInput, toSlider, groups_def, plotter_id);

    function makeToInputCallback(toSlider, fromInput, toInput, groups_def, plotter_id) {
      return function(e) {
        controlToInput(toSlider, fromInput, toInput, toSlider, groups_def, plotter_id);
      }
    }
    toInput.oninput = makeToInputCallback(toSlider, fromInput, toInput, groups_def, plotter_id);

  }


}




document.addEventListener('DOMContentLoaded', initiate, false);


